module.exports = () => {
  return {
    anchor_type: {
      label: '锚点类型',
      type: 'label',
      is_filter: true,
      value: '应用下载-游戏',
    },
  };
};
